export const toCapitalize = (str: string, allWords: boolean): string => {
  return str.split(' ').map(
    (word: string, index: number): string => {
      if (allWords || index > 0) {
        return word.substr(0, 1).toUpperCase() + (word.length > 0 ? word.substr(1).toLowerCase() : '')
      }
      return word.toLowerCase();
    }
  ).join(' ');
}